import React, { useState } from "react";
import "./ChangePassword.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import api from "../../services/BackendServices";
import { parseJwt } from "../../utils/parseJwt";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const ChangePassword: React.FC = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const navigate = useNavigate();
  const USER_ID = parseJwt(
    useSelector((state: RootState) => state.userProfile.token)
  ).id;

  const togglePasswordVisibility = (field: string) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field as keyof typeof prevState],
    }));
  };

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Todos los campos son obligatorios");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    setLoading(true);

    try {
      await api.SecurityServices.changePassword({
        userId: USER_ID,
        currentPassword,
        newPassword,
      });

      toast.success("Contraseña actualizada correctamente");
      navigate("/chat");
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message || "Error al cambiar la contraseña"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-container">
      <div className="card-container">
        <h2>Cambiar Contraseña</h2>
        <form onSubmit={handleChangePassword} className="change-password-form">
          <div className="input-container">
            <input
              type={showPassword.current ? "text" : "password"}
              placeholder="Contraseña actual"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
            <FontAwesomeIcon
              icon={showPassword.current ? faEyeSlash : faEye}
              onClick={() => togglePasswordVisibility("current")}
              className="eye-icon"
            />
          </div>
          <div className="input-container">
            <input
              type={showPassword.new ? "text" : "password"}
              placeholder="Nueva contraseña"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <FontAwesomeIcon
              icon={showPassword.new ? faEyeSlash : faEye}
              onClick={() => togglePasswordVisibility("new")}
              className="eye-icon"
            />
          </div>
          <div className="input-container">
            <input
              type={showPassword.confirm ? "text" : "password"}
              placeholder="Confirmar nueva contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <FontAwesomeIcon
              icon={showPassword.confirm ? faEyeSlash : faEye}
              onClick={() => togglePasswordVisibility("confirm")}
              className="eye-icon"
            />
          </div>
          {error && <p className="error-text">{error}</p>}
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Actualizando..." : "Actualizar"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
